import React, { useState } from "react";
import parse from 'html-react-parser'

import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Row,
    Col,
} from 'reactstrap';



export default function SuccessDialog(props) {
    const { id, content, btnText = 'OK' } = props
    const [show, setShow] = useState(true);

    const onHandleClick = () => {
        setShow(false)
        if (props.onHide) {
            props.onHide()
        }
    };

    return (
        <Modal id={id} isOpen={show} keyboard={true} centered>
            <ModalBody>
                <div className="text-center success-dialog">
                    <i className="fas fa-check icon-circle"></i><br />
                    <p>{parse(content)}</p>
                    <Row>
                        <Col className="text-center" md={12}>
                            <Button color="primary" className="btn-block" size="lg" style={{ margin:'auto', borderRadius: '0.5rem'}} onClick={onHandleClick}>{btnText}</Button>
                        </Col>
                    </Row>
                </div>
            </ModalBody>
        </Modal>
    );
}
